import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import { useAppConfig, useFormatAmount } from "../../../shared";

const tableCellStyle = {
  borderBottom: "1px solid #E6E6E6",
};
export const OrderListTable = ({ isRefund = false, state }) => {
  const { taxTerm } = useAppConfig();
  const formatAmount = useFormatAmount();
  const paymentType = state?.data?.payments?.filter((i) => {
    return i?.payment_type_id === 105;
  });
  return (
    <Paper sx={{ boxShadow: "none" }}>
      <TableContainer>
        <Table sx={{ minWidth: 700 }} aria-label="spanning table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Item</TableCell>
              <TableCell align="left">Quantity</TableCell>
              <TableCell align="left">Product Price</TableCell>
              <TableCell align="left">Sale Price</TableCell>
              <TableCell align="right">Total Price</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {state?.data?.products?.map((item, index) => {

              return (
                <>
                  <TableRow>
                    <TableCell sx={tableCellStyle} key={1}>
                      {item?.product_name} {item.has_tax ? "*" : ""}{" "}
                      {state.data?.customer?.id &&
                      !item.loyalty_points_accumulated
                        ? "^"
                        : ""}
                      <Typography variant="body2" color="#636363" mt="4px">
                        {item?.child_products?.length > 0
                          ? item.child_products.map((data, i) => (
                              <div style={{ marginTop: "2px" }}>
                                {data.product_name}
                                {data.has_tax ? "*" : ""}
                                {data?.child_products?.length > 0 &&
                                  data?.child_products?.map((item) => (
                                    <div
                                      style={{
                                        marginLeft: "8px",
                                        marginTop: "2px",
                                      }}
                                    >
                                      {item?.product_name}
                                      {item.has_tax ? "*" : ""}
                                    </div>
                                  ))}
                              </div>
                            ))
                          : ""}
                      </Typography>
                    </TableCell>
                    <TableCell sx={tableCellStyle} key={2}>
                      {item?.quantity}
                      <Typography variant="body2" color="#636363" mt="4px">
                        {item?.child_products?.length > 0
                          ? item?.child_products?.map((data, i) => (
                              <div style={{ marginTop: "2px" }}>
                                {data?.quantity}
                                {data?.child_products?.length > 0
                                  ? data.child_products.map((ch, i) => (
                                      <div style={{ marginTop: "2px" }}>
                                        {ch.quantity}
                                      </div>
                                    ))
                                  : ""}
                              </div>
                            ))
                          : ""}
                      </Typography>
                    </TableCell>
                    <TableCell sx={tableCellStyle} key={3}>
                      {formatAmount(item?.mrp)}
                      <Typography variant="body2" color="#636363" mt="4px">
                        {item?.child_products?.length > 0
                          ? item?.child_products?.map((data, i) => (
                              <div style={{ marginTop: "2px" }}>
                                {formatAmount(data?.mrp)}
                                {data?.child_products?.length > 0
                                  ? data.child_products?.map((ch, i) => (
                                      <div style={{ marginTop: "2px" }}>
                                        {formatAmount(ch?.mrp)}
                                      </div>
                                    ))
                                  : ""}
                              </div>
                            ))
                          : ""}
                      </Typography>
                    </TableCell>
                    <TableCell sx={tableCellStyle} key={4}>
                      {formatAmount(item?.price)}
                      <Typography variant="body2" color="#636363" mt="4px">
                        {item?.child_products?.length > 0
                          ? item.child_products.map((data, i) => (
                              <div style={{ marginTop: "2px" }}>
                                {formatAmount(data?.price)}
                                {data?.child_products?.length > 0
                                  ? data.child_products.map((ch, i) => (
                                      <div style={{ marginTop: "2px" }}>
                                        {formatAmount(ch?.price)}
                                      </div>
                                    ))
                                  : ""}
                              </div>
                            ))
                          : ""}
                      </Typography>
                    </TableCell>
                    <TableCell
                      sx={{ ...tableCellStyle, verticalAlign: "bottom" }}
                      align="right"
                      key={5}
                    >
                      {formatAmount(item?.group_total)}
                    </TableCell>
                  </TableRow>
                </>
              );
            })}
            <TableRow>
              <TableCell colSpan={3}></TableCell>
              <TableCell
                sx={{
                  borderBottom: "1px solid #E6E6E6",
                  borderLeft: "1px solid #E6E6E6",
                }}
                align="left"
              >
                Sub Total (In {taxTerm})
              </TableCell>
              <TableCell
                sx={{
                  borderBottom: "1px solid #E6E6E6",
                  fontWeight: "500",
                }}
                align="right"
              >
                {formatAmount(state.data.subtotal_inc_tax)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={3}></TableCell>
              <TableCell
                sx={{
                  borderBottom: "1px solid #E6E6E6",
                  borderLeft: "1px solid #E6E6E6",
                }}
              >
                Coupons/Discounts
              </TableCell>
              <TableCell
                sx={{
                  borderBottom: "1px solid #E6E6E6",
                  color: "#636363",
                }}
                align="right"
              >
                {formatAmount(state.data?.total_discount)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={3}></TableCell>
              <TableCell
                sx={{
                  borderBottom: "1px solid #E6E6E6",
                  borderLeft: "1px solid #E6E6E6",
                }}
              >
                Rounding
              </TableCell>
              <TableCell
                sx={{
                  borderBottom: "1px solid #E6E6E6",
                  color: "#636363",
                }}
                align="right"
              >
                {formatAmount(state.data?.round_off)}
              </TableCell>
            </TableRow>
            {!isRefund && (
              <>
                <TableRow>
                  <TableCell colSpan={3}></TableCell>
                  <TableCell
                    sx={{
                      borderBottom: "1px solid #E6E6E6",
                      borderLeft: "1px solid #E6E6E6",
                      color: "#636363",
                      fontWeight: 700,
                    }}
                  >
                    Total (In {taxTerm})
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom: "1px solid #E6E6E6",
                      fontWeight: 700,
                    }}
                    align="right"
                  >
                    {formatAmount(state?.data?.grand_total)}
                  </TableCell>
                </TableRow>
                {paymentType?.length !== 0 && (
                  <TableRow>
                    <TableCell colSpan={3}></TableCell>
                    <TableCell
                      sx={{
                        borderBottom: "1px solid #E6E6E6",
                        borderLeft: "1px solid #E6E6E6",
                        color: "#636363",
                        fontWeight: 700,
                      }}
                    >
                      Total Due (In {taxTerm})
                    </TableCell>
                    <TableCell
                      sx={{
                        borderBottom: "1px solid #E6E6E6",
                        fontWeight: 700,
                      }}
                      align="right"
                    >
                      {formatAmount(state.data?.client_account_total)}
                    </TableCell>
                  </TableRow>
                )}
              </>
            )}

            <TableRow>
              <TableCell colSpan={3}></TableCell>
              <TableCell
                sx={{
                  borderBottom: "1px solid #E6E6E6",
                  borderLeft: "1px solid #E6E6E6",
                  fontWeight: "400",
                }}
              >
                Total Includes {taxTerm} of
              </TableCell>
              <TableCell
                sx={{
                  borderBottom: "1px solid #E6E6E6",
                  fontWeight: "400",
                }}
                align="right"
              >
                {formatAmount(state.data?.tax_amount)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={3}></TableCell>
              <TableCell
                sx={{
                  display: "flex",
                  borderLeft: "1px solid #E6E6E6",
                  fontWeight: "500",
                  bgcolor: "#E1FBF2",
                  p: "12px 16px",
                  color: "#0F875B",
                  lineHeight: "16px",
                }}
              >
                <img
                  alt="dis_icon"
                  src="/icons/ic_discount.svg"
                  style={{
                    width: "18.5px",
                    marginRight: "8px",
                    filter:
                      "brightness(0) saturate(100%) invert(38%) sepia(14%) saturate(4028%) hue-rotate(118deg) brightness(95%) contrast(88%)",
                  }}
                />
                Total Savings
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "500",
                  bgcolor: "#E1FBF2",
                  p: "12px 16px",
                  color: "#0F875B",
                }}
                align="right"
              >
                {formatAmount(state.data?.saved_amount)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
